import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { ComponentSharedModule } from '@components/component.shared.module';
import { UiCommentComponent } from '@components/ui-comment/ui-comment.component';
import { UiCommentsComponent } from '@components/ui-comment/ui-comments.component';
import { MatTooltipModule } from '@directives/ui-tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { UiAutofocusModule } from '@uipath/angular/directives/ui-autofocus';
import { UiDateFormatModule } from '@uipath/angular/directives/ui-dateformat';
import { UiScrollIntoViewModule } from '@uipath/angular/directives/ui-scroll-into-view';
import { UiSpinnerButtonModule } from '@uipath/angular/directives/ui-spinner-button';

@NgModule({
    imports: [
        CommonModule,
        ComponentSharedModule,
        TranslateModule,
        MatIconModule,
        MatInputModule,
        MatMenuModule,
        MatTooltipModule,
        MatButtonModule,
        UiAutofocusModule,
        UiScrollIntoViewModule,
        UiDateFormatModule,
        UiSpinnerButtonModule,
    ],
    declarations: [
        UiCommentComponent,
        UiCommentsComponent,
    ],
    exports: [
        UiCommentsComponent,
    ],
})
export class UiCommentsModule { }
